export default {
  namespaced: true,
  institutions: {
    title: 'Instituciones | Institución',
    name: 'nombre',
    description: 'descripción',
    tenant: 'Tenant',
    institutions: 'Instituciones',
    select: 'Seleccione una o más instituciones'
  }
}
